export const USER_FUNCTION_USER = 'user';
export const USER_FUNCTION_ADMIN = 'admin';

// Backward-compatible aliases
export const ACCOUNT_FUNCTION_USER = USER_FUNCTION_USER;
export const ACCOUNT_FUNCTION_ADMIN = USER_FUNCTION_ADMIN;

export function isAdmin(userOrAccount) {
  return userOrAccount?.function === USER_FUNCTION_ADMIN;
}

export function isUser(userOrAccount) {
  return userOrAccount?.function === USER_FUNCTION_USER;
}

export function homePathFor(user, { memberships = [], account = null } = {}) {
  if (isAdmin(user)) {
    return '/llm-catalog';
  }
  if (memberships.length === 0) {
    return '/select-account';
  }
  if (memberships.length > 1 && !account) {
    return '/select-account';
  }
  return '/agents';
}

export function adminHomePath() {
  return '/llm-catalog';
}

export function userHomePath() {
  return '/agents';
}

export function canManageTeam(membership) {
  return membership?.role === 'owner' || membership?.role === 'admin';
}

export function membershipRoleLabel(role) {
  const labels = {
    owner: 'Proprietário',
    admin: 'Administrador',
    member: 'Membro',
  };
  return labels[role] || role;
}
